import { zEmployeeCommonSchema } from "./employee.common";
export const zEmployeeSchemaDom = zEmployeeCommonSchema;
export const zEmployeeSchemaCreateDom = zEmployeeSchemaDom.omit({ id: true });
